import { render, staticRenderFns } from "./UserPackageInformation.vue?vue&type=template&id=ecce48e4&scoped=true"
import script from "./UserPackageInformation.vue?vue&type=script&lang=js"
export * from "./UserPackageInformation.vue?vue&type=script&lang=js"
import style0 from "./UserPackageInformation.vue?vue&type=style&index=0&id=ecce48e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecce48e4",
  null
  
)

export default component.exports